// @ts-check

import {
  GET_PRICING_PLAN,
  GET_BILLING_PLAN,
  ADD_ACCOUNT_BALANCE,
  GET_CREDIT_CARDS,
  DELETE_CREDIT_CARD,
  ADD_CREDIT_CARD,
  VERIFY_CREDIT_CARD,
  UPDATE_CREDIT_CARD,
  UPDATE_BILLING_SETTINGS
} from './actionTypes';
import { getActionStatusName } from '@/store/helpers';

export const getPricingPlanStatus = state => state.status[getActionStatusName(GET_PRICING_PLAN)] || {};
export const getBillingPlanStatus = state => state.status[getActionStatusName(GET_BILLING_PLAN)] || {};
export const addAccountBalanceStatus = state => state.status[getActionStatusName(ADD_ACCOUNT_BALANCE)] || {};
export const getCreditCardsStatus = state => state.status[getActionStatusName(GET_CREDIT_CARDS)] || {};
export const deleteCreditCardStatus = state => state.status[getActionStatusName(DELETE_CREDIT_CARD)] || {};
export const addCreditCardStatus = state => state.status[getActionStatusName(ADD_CREDIT_CARD)] || {};
export const verifyCreditCardStatus = state => state.status[getActionStatusName(VERIFY_CREDIT_CARD)] || {};
export const updateCreditCardStatus = state => state.status[getActionStatusName(UPDATE_CREDIT_CARD)] || {};
export const updateBillingSettingsStatus = state => state.status[getActionStatusName(UPDATE_BILLING_SETTINGS)] || {};
